import script from "./SimulationAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulationAttachments.vue?vue&type=script&setup=true&lang=js"

import "./SimulationAttachments.vue?vue&type=style&index=0&id=36131f0a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36131f0a"]])

export default __exports__